<div dropdown class="btn-group dropdown" container="body">
  <a dropdownToggle type="button" class="btn btn-link text-secondary dropdown-toggle">
    <span class="text-muted text-sm" i18n>Via</span>
    <ng-container *ngIf="selectedChannelOption">
      <img [src]="selectedChannelOption?.logo" alt="" height="15" />
    </ng-container>
  </a>

  <ul *dropdownMenu class="dropdown-menu px-0">
    <li *ngFor="let t of messagingChannelOptions" class="px-2">
      <button
        type="button"
        class="p-1"
        isFocusing
        (mouseenter)="isWhatsappTemplatesOpen = false"
        [disabled]="(isProduction && !t.isProdReady) || !(isMsgChannelAvailable | call : t : guestEmail)"
        (click)="onChangeChannel(t)"
        #btn="isFocusing"
        [matTooltipDisabled]="(!isProduction || t.isProdReady) && (isMsgChannelAvailable | call : t : guestEmail)"
        [matTooltip]="isProduction && !t.isProdReady ? 'Coming Soon' : getChannelDisabledTooltip(t)"
        matTooltipPosition="right"
        *ngIf="t.id !== MessagingChannelType.Whatsapp"
      >
        <div class="d-flex gap-1">
          <div>
            <img
              [src]="t.logo"
              height="15"
              [style.filter]="isFocusing || selectedChannel === t.id ? 'none' : 'grayscale(1)'"
            />
          </div>
          <div class="text-left text-sm">
            <div>
              {{ t.label }}
            </div>
            <div class="text-xs" *ngIf="!t.isSubscriptionRequired">
              <span class="text-muted">Free</span>
              <ng-container *ngIf="(!isProduction || t.isProdReady) && t.oauth">
                •
                <span
                  class="text-info clickable"
                  (click)="onConnect(t.id)"
                  *ngIf="!messagingChannels?.[t.channel]?.enabled"
                  i18n
                  >Connect Now</span
                >
                <span class="text-success text-semi-bold" *ngIf="messagingChannels?.[t.channel]?.enabled" i18n
                  >Connected</span
                >
              </ng-container>
            </div>
            <div class="text-xs" *ngIf="t.isSubscriptionRequired">
              <ng-container *ngIf="isMessagingSubscribed">
                <span class="text-success text-semi-bold">Subscribed</span>
              </ng-container>
              <ng-container *ngIf="!isMessagingSubscribed">
                <span class="text-info clickable" (click)="onSubscribeMessaging()">Subscribe Now</span>
              </ng-container>
            </div>
          </div>
        </div>
      </button>

      <ng-container
        [ngTemplateOutlet]="whatsappBtn"
        [ngTemplateOutletContext]="{ channel: t }"
        *ngIf="t.id === MessagingChannelType.Whatsapp"
      ></ng-container>
    </li>
  </ul>
</div>

<ng-template #whatsappBtn let-channel="channel">
  <button
    type="button"
    class="p-1"
    isFocusing
    (mouseenter)="isWhatsappTemplatesOpen = !isWhatsappTemplatesOpen"
    (click)="onChangeChannel(channel)"
    cdkOverlayOrigin
    #whatsappTemplatesTrigger="cdkOverlayOrigin"
    #btn="isFocusing"
    [matTooltipDisabled]="isMsgChannelAvailable | call : channel : guestEmail"
    [matTooltip]="'Guest doesn\'t have ' + channel.label + ' email'"
    matTooltipPosition="right"
  >
    <div class="d-flex gap-1">
      <div>
        <img
          [src]="channel.logo"
          height="15"
          [style.filter]="isFocusing || selectedChannel === channel.id ? 'none' : 'grayscale(1)'"
        />
      </div>
      <div class="text-left text-sm">
        <div>
          {{ channel.label }}
        </div>
        <div class="text-xs">
          <span class="text-muted">Free</span>
          <ng-container>
            •
            <span class="text-info clickable" (click)="onConnect(channel.id)" *ngIf="!isWhatsappFreeMessageEnabled" i18n
              >Connect Now</span
            >
            <span class="text-success text-semi-bold" *ngIf="isWhatsappFreeMessageEnabled" i18n>Connected</span>
          </ng-container>
        </div>
      </div>
    </div>
  </button>
  <ng-template
    cdkConnectedOverlay
    (overlayOutsideClick)="isWhatsappTemplatesOpen = false"
    [cdkConnectedOverlayOffsetX]="15"
    [cdkConnectedOverlayOffsetY]="15"
    [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' }]"
    [cdkConnectedOverlayOrigin]="whatsappTemplatesTrigger"
    [cdkConnectedOverlayOpen]="isWhatsappTemplatesOpen"
  >
    <div>
      <ul class="dropdown-menu show position-relative" style="top: 0" (click)="isWhatsappTemplatesOpen = false">
        <li
          matTooltip="Please enter guest WhatsApp number before you can send the message"
          i18n-matTooltip
          [matTooltipDisabled]="!!guest?.whatsapp_phone"
          matTooltipPosition="right"
        >
          <button type="button" (click)="onSendWhatsappTemplate()" [disabled]="!guest?.whatsapp_phone">
            Send Predefined Message
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</ng-template>
